<template>
	<section v-if="api" ref="el" data-component="club-timetable" data-section-intersect="light" :data-anchor="$t('timetable', 'Horário')">
		<div class="row">
			<div class="xxlarge-16 col">
				<p class="-subhead-2 -uppercase upper-title">{{ upperTitle }}</p>
				<RollingTitle :label="title" />
			</div>
		</div>
		<div class="timetable-wrapper">
			<Timetable :api="api" :classes="classes" class="timetable active" />
		</div>
	</section>
</template>

<script setup>
import { gsap } from 'gsap/all'
import { Timetable } from '~/components/fragments'
import { RollingTitle } from '~/components/primitives'

import { useStringTranslation } from '@/i18n'

const props = defineProps({
	upperTitle: { type: String, default: '' },
	title: { type: String, default: '' },
	api: { type: [Boolean, String], default: false },
	classes: { type: Array, default: () => {} },
})
const el = ref(null)
const $t = useStringTranslation()

// porto link -> https://join.phive.pt/wp-json/jet-cct/aulas_agendadas/?nome_clube=Phive%20Porto%20Health%20Club
</script>

<style lang="scss" scoped>
[data-component='club-timetable'] {
	position: relative;

	display: flex;
	flex-direction: column;
	width: var(--computed-100vw);
	padding: rs(200) 0 rs(60) 0;

	color: var(--color-subduedYellow);
	background-color: var(--color-darkBrown);

	overflow: hidden;

	.col {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: rs(24);
	}

	.upper-title {
		text-align: center;
	}

	.title {
		@include max-screen($xsmall) {
			@include title-2;
		}
	}

	.timetable-wrapper {
		.timetable {
			opacity: 1;
		}
	}
}
</style>
